import { Event, DestinationPlugin } from '@amplitude/analytics-types';
import { datadogRum } from '@datadog/browser-rum';

export class AmplitudeDataDogPlugin implements DestinationPlugin {
    name = 'AmplitudeDataDogPlugin';
    type = 'destination' as const;

    // eslint-disable-next-line require-await
    async execute(event: Event) {
        if (event.event_type !== '$identify') {
            datadogRum.addAction(event.event_type, {
                ...(event.event_properties || {})
            });
        }

        return {
            code: 200,
            event: event,
            message: 'Event sent to DataDog'
        };
    }
}
